import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../../system/client/src/services/api';
import './NewToTradeCard.css';

/* "38 companies near BS1 started importing in June 2026" — counts only (no
 * quota), for the area last searched on the Traders page, or the whole UK. */
const NewToTradeCard = () => {
    const [summary, setSummary] = useState(null);

    useEffect(() => {
        let area = {};
        try {
            area = JSON.parse(localStorage.getItem('traders_filters') || '{}') || {};
        } catch { /* no saved area */ }
        const params = {};
        if (area.postCode) {
            params.postCode = area.postCode;
            if (Number(area.radiusMiles) > 0) params.radiusMiles = area.radiusMiles;
        }
        api.get('traders/new/summary', { params })
            .then(setSummary)
            .catch(() => {});
    }, []);

    if (!summary || !summary.month || !summary.total) return null;

    const where = summary.area
        ? summary.area.radiusMiles
            ? `within ${summary.area.radiusMiles} miles of ${summary.area.postCode.toUpperCase()}`
            : `in ${summary.area.postCode.toUpperCase()}`
        : 'across the UK';

    return (
        <section className="ntt-card">
            <div>
                <span className="kicker">New to trade · {summary.month.label}</span>
                <p className="ntt-card-lead">
                    <strong>{summary.importers.toLocaleString()}</strong> companies {where} started importing
                    {summary.exporters > 0 && (
                        <>, and <strong>{summary.exporters.toLocaleString()}</strong> started exporting</>
                    )}.
                </p>
                <p className="ntt-card-sub">New traders often don&apos;t have a forwarder yet.</p>
            </div>
            <Link to="/new-to-trade" className="btn btn-primary">See who they are →</Link>
        </section>
    );
};

export default NewToTradeCard;
